import * as form from '../form';

export const substanceDrugUsage = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        DrugType: form.radio(xitem.DrugType),
        FirstUse: form.datecontrol(xitem.FirstUse),
        RecentUse: form.datecontrol(xitem.RecentUse),
        NatureOfUse: form.textarea(xitem.NatureOfUse),
        UseWhileEmployed: form.branch(xitem.UseWhileEmployed),
        UseWithClearance: form.branch(xitem.UseWithClearance),
        UseInFuture: form.branch(xitem.UseInFuture),
        Explanation: form.textarea(xitem.Explanation),
        Comments: form.textarea(xitem.Comments),
        DrugTypeOther: form.textarea(xitem.DrugTypeOther),
        HowManyTimes: form.text(xitem.HowManyTimes),
        Reason: form.textarea(xitem.Reason),
        UseWhileEmployedPosition: form.text(xitem.UseWhileEmployedPosition),
        UseWhileEmployedExplanation: form.textarea(xitem.UseWhileEmployedExplanation),
        UseWithClearanceExplanation: form.textarea(xitem.UseWithClearanceExplanation),
        UseInFutureExplanation: form.textarea(xitem.UseInFutureExplanation),
      },
    };
  });
  return {
    UsedDrugs: form.branch(data.UsedDrugs),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
